import PropTypes from "prop-types";

const ProgressBar = ({ percentage, reference, unit, ...props }) => {
  const greenColor = "#008a16";
  const yellowColor = "#FFD100";
  const redColor = "#DC0A0A";
  let stopColor = percentage <= 80 ? greenColor : yellowColor;
  stopColor = percentage > 100 ? redColor : stopColor;

  const fillerStyles = {
    width: `${percentage}%`,
    backgroundColor: stopColor,
    borderRadius: "inherit"
  };

  return (
    <div className="ProgressBar flex flex-col" {...props}>
      <div className="flex flex-row">
        <div className="flex-1 items-start">
          <div className="grid justify-items-start text-xs" style={{ color: stopColor }}>
            {percentage !== undefined ? percentage.toFixed(2) + "%" : ""}
          </div>
        </div>
        <div className="flex-1 items-start">
          <div className="grid justify-items-end text-xs" style={{ color: "grey" }}>
            {reference !== undefined && 0 !== reference
              ? reference + (unit !== undefined && unit !== "" ? " " + unit : "")
              : ""}
          </div>
        </div>
      </div>
      <div className="flex rounded-[25px] h-[7px] w-full bg-[#E6E7EB]">
        <div style={fillerStyles} />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number,
  reference: PropTypes.number,
  unit: PropTypes.string
};

ProgressBar.defaultProps = {
  percentage: undefined,
  reference: undefined,
  unit: undefined
};

export default ProgressBar;
